export default "//yastatic.net/s3/distribution/pythia/frontend/_/567ad44f4130e8ac943c13dc36cd9fa7.png";